/**
 * @generated SignedSource<<a5cd6d5548a8afbb2ccbd9b3e9b18ccf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowSoldPricingGuidance_item$data = {
  readonly pricingGuidance: {
    readonly pricingGuidanceType: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useShowPricingGuidance_item">;
  readonly " $fragmentType": "useShowSoldPricingGuidance_item";
};
export type useShowSoldPricingGuidance_item$key = {
  readonly " $data"?: useShowSoldPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowSoldPricingGuidance_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowSoldPricingGuidance_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pricingGuidanceType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8412522d387e0eb9db1789c09ff25d4f";

export default node;
